module.exports = __webpack_public_path__ + "img/Outdoor.30ae0889.jpg";